import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-data-table',{attrs:{"headers":_vm.headers,"items":_vm.records,"loading":_vm.loading,"sort-by":"dateTime","sort-desc":"","disable-pagination":"","fixed-header":"","height":"396"},scopedSlots:_vm._u([{key:"item.date",fn:function(ref){
var item = ref.item;
return [_c('w-inline-text',{attrs:{"bold":"","text":_vm.formatedDate(item.date)}})]}},{key:"item.month",fn:function(ref){
var item = ref.item;
return [_c('w-inline-text',{attrs:{"bold":"","text":_vm.translateMonth(item.month, true)}})]}},{key:"item.type",fn:function(ref){
var item = ref.item;
return [_c('w-inline-text',{attrs:{"text":_vm.$t(("balance.type_" + (item.type)))}})]}},{key:"item.direction",fn:function(ref){
var item = ref.item;
return [(item.direction === 'IN')?_c(VIcon,{attrs:{"color":"teal"}},[_vm._v("mdi-plus-circle-outline")]):_vm._e(),(item.direction === 'OUT')?_c(VIcon,{attrs:{"color":"red"}},[_vm._v("mdi-minus-circle-outline")]):_vm._e()]}},{key:"item.value",fn:function(ref){
var item = ref.item;
return [_c('w-chip',{attrs:{"outlined":"","text":item.value}})]}},{key:"item.plateBase",fn:function(ref){
var item = ref.item;
return [_c('w-inline-text',{attrs:{"text":_vm.priceFormat(item.plateBase)}})]}},{key:"item.plate",fn:function(ref){
var item = ref.item;
return [_c('w-inline-text',{attrs:{"text":_vm.priceFormat(item.plate)}})]}},{key:"item.consult",fn:function(ref){
var item = ref.item;
return [(['ABSENCE_REQUEST', 'MANUAL_GATHERING', 'GATHERING', 'PAY_SLIP'].includes(item.type))?_c(VBtn,{attrs:{"icon":"","color":"blue"},on:{"click":function($event){return _vm.consult(item)}}},[_c(VIcon,[_vm._v("mdi-hammer-screwdriver")])],1):_vm._e()]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }